module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MDAiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgNSAzIj48cGF0aCBmaWxsPSIjQzEyNzJEIiBkPSJNMCAwaDV2M0gweiIvPjxwYXRoIGZpbGw9IiMwMDZBNDQiIGQ9Ik0wIDBoNXYySDB6Ii8+PHBhdGggZmlsbD0iI0ZEQjkxMyIgZD0iTTAgMGg1djFIMHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/ltu.svg
// module id = LwGC
// module chunks = 0